import { useQuery, useQueryClient } from "react-query";
import { useApiError } from "src/hooks/useApiError";
import { getBillHistory } from "src/service/pay";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { useRecoilState } from "recoil";
import { userInfoAtom } from "src/atoms";
import { ProductKey, USE_MOCK_DATA } from "src/config/config";
import { useState } from "react";
import { mockBillHistory } from "src/mocks/billHistoryMock";

interface IUseCheckProductAvailableProps {
  offset?: number;
  limit?: number;
  order?: string;
  product?: ProductKey;
  onSuccess?: () => void;
  onError?: () => void;
}

export function useGetBillHistory({
  offset = 0,
  limit = 5,
  order = "-his.entry_time",
  product = getProductFromSessionStorage(),
  onSuccess,
  onError,
}: IUseCheckProductAvailableProps) {
  const { handleError } = useApiError();
  const [userInfo] = useRecoilState(userInfoAtom);
  const queryClient = useQueryClient();

  // 목업 데이터 사용 시의 상태값
  const [mockTotalCount] = useState<number>(mockBillHistory.length);
  const [mockTotalPageNumber] = useState<number>(
    Math.ceil(mockBillHistory.length / limit)
  );

  // API 호출 시의 상태값
  const [apiTotalCount, setApiTotalCount] = useState<number>(0);
  const [apiTotalPageNumber, setApiTotalPageNumber] = useState<number>(0);

  const filter = {
    offset,
    limit,
    order,
    product,
  };

  const { isLoading: isBillHistoryLoading, data } = useQuery(
    ["getBillHistory", filter],
    async () => {
      if (USE_MOCK_DATA) {
        // 목업 데이터 사용
        const start = offset;
        const end = offset + limit;
        const paginatedData = mockBillHistory.slice(start, end);

        return {
          billHistory: paginatedData,
          count: mockBillHistory.length,
        };
      } else {
        // 실제 API 호출
        return await getBillHistory(filter);
      }
    },
    {
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      onSuccess: (res) => {
        if (!USE_MOCK_DATA) {
          setApiTotalCount(res?.count);
          setApiTotalPageNumber(Math.ceil(res?.count / limit));
        }
        onSuccess?.();
      },
      onError: handleError,
    }
  );

  return {
    isBillHistoryLoading,
    billHistory: data?.billHistory ?? [],
    totalCount: USE_MOCK_DATA ? mockTotalCount : apiTotalCount,
    totalPageNumber: USE_MOCK_DATA ? mockTotalPageNumber : apiTotalPageNumber,
  };
}
